import { jsx as _jsx } from "react/jsx-runtime";
import { Australia } from "@faire/web--source/slate/icons/flags/Australia";
import { Austria } from "@faire/web--source/slate/icons/flags/Austria";
import { Belgium } from "@faire/web--source/slate/icons/flags/Belgium";
import { Canada } from "@faire/web--source/slate/icons/flags/Canada";
import { Denmark } from "@faire/web--source/slate/icons/flags/Denmark";
import { Finland } from "@faire/web--source/slate/icons/flags/Finland";
import { France } from "@faire/web--source/slate/icons/flags/France";
import { Germany } from "@faire/web--source/slate/icons/flags/Germany";
import { Ireland } from "@faire/web--source/slate/icons/flags/Ireland";
import { Italy } from "@faire/web--source/slate/icons/flags/Italy";
import { Luxembourg } from "@faire/web--source/slate/icons/flags/Luxembourg";
import { Netherlands } from "@faire/web--source/slate/icons/flags/Netherlands";
import { Norway } from "@faire/web--source/slate/icons/flags/Norway";
import { Portugal } from "@faire/web--source/slate/icons/flags/Portugal";
import { Spain } from "@faire/web--source/slate/icons/flags/Spain";
import { Sweden } from "@faire/web--source/slate/icons/flags/Sweden";
import { Switzerland } from "@faire/web--source/slate/icons/flags/Switzerland";
import { UnitedKingdom } from "@faire/web--source/slate/icons/flags/UnitedKingdom";
import { UnitedStates } from "@faire/web--source/slate/icons/flags/UnitedStates";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import React from "react";
export var CountryFlag = function(param) {
    var country = param.country, _param_size = param.size, size = _param_size === void 0 ? "16px" : _param_size;
    switch(country){
        case ISO3166Alpha3.USA:
            return /*#__PURE__*/ _jsx(UnitedStates, {
                fontSize: size
            });
        case ISO3166Alpha3.CAN:
            return /*#__PURE__*/ _jsx(Canada, {
                fontSize: size
            });
        case ISO3166Alpha3.GBR:
            return /*#__PURE__*/ _jsx(UnitedKingdom, {
                fontSize: size
            });
        case ISO3166Alpha3.CHE:
            return /*#__PURE__*/ _jsx(Switzerland, {
                fontSize: size
            });
        case ISO3166Alpha3.NOR:
            return /*#__PURE__*/ _jsx(Norway, {
                fontSize: size
            });
        case ISO3166Alpha3.NLD:
            return /*#__PURE__*/ _jsx(Netherlands, {
                fontSize: size
            });
        case ISO3166Alpha3.FRA:
            return /*#__PURE__*/ _jsx(France, {
                fontSize: size
            });
        case ISO3166Alpha3.DEU:
            return /*#__PURE__*/ _jsx(Germany, {
                fontSize: size
            });
        case ISO3166Alpha3.ESP:
            return /*#__PURE__*/ _jsx(Spain, {
                fontSize: size
            });
        case ISO3166Alpha3.ITA:
            return /*#__PURE__*/ _jsx(Italy, {
                fontSize: size
            });
        case ISO3166Alpha3.AUT:
            return /*#__PURE__*/ _jsx(Austria, {
                fontSize: size
            });
        case ISO3166Alpha3.BEL:
            return /*#__PURE__*/ _jsx(Belgium, {
                fontSize: size
            });
        case ISO3166Alpha3.IRL:
            return /*#__PURE__*/ _jsx(Ireland, {
                fontSize: size
            });
        case ISO3166Alpha3.LUX:
            return /*#__PURE__*/ _jsx(Luxembourg, {
                fontSize: size
            });
        case ISO3166Alpha3.SWE:
            return /*#__PURE__*/ _jsx(Sweden, {
                fontSize: size
            });
        case ISO3166Alpha3.DNK:
            return /*#__PURE__*/ _jsx(Denmark, {
                fontSize: size
            });
        case ISO3166Alpha3.FIN:
            return /*#__PURE__*/ _jsx(Finland, {
                fontSize: size
            });
        case ISO3166Alpha3.PRT:
            return /*#__PURE__*/ _jsx(Portugal, {
                fontSize: size
            });
        case ISO3166Alpha3.AUS:
            return /*#__PURE__*/ _jsx(Australia, {
                fontSize: size
            });
        default:
            return null;
    }
};
